// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-render .formio-component-well p li {
  padding: 10px;
}
.form-render .formio-component-filecomponent .fileSelector {
  padding: 15px;
  border: 2px dashed #ddd;
  text-align: center;
}
.form-render .formio-component-filecomponent .fileSelector .browse {
  cursor: pointer;
}
.form-render .formio-component-filecomponent .fileSelector .fa {
  font-size: 20px;
  margin-right: 5px;
}
.form-render label span {
  color: darkslategray;
  /*font-family: Quicksand;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 25px;
  color: red;*/
}
.form-render .formio-error-wrapper {
  background-color: transparent;
  border-color: transparent;
  padding: 0;
}
.form-render .formio-component-select .form-control.is-invalid.dropdown {
  background-position: right calc(2.8em + 0.1875rem) center;
}
.form-render .formio-component-select .choices__list--dropdown.is-active {
  position: relative;
}
.form-render .formio-component-modal-wrapper .formio-dialog.formio-dialog-theme-default {
  padding-bottom: 50px;
  padding-top: 50px;
}
.form-render .formio-component-modal-wrapper .formio-dialog.formio-dialog-theme-default .formio-dialog-content {
  min-height: 80%;
}
.form-render .formio-component.has-feedback .invalid-feedback {
  display: block;
  color: inherit;
  margin-top: 4px;
}
.form-render .page-item > button.page-link {
  color: #275362 !important;
}
.form-render .page-item.active > button {
  background-color: #275362 !important;
  color: white !important;
}
.form-render .bg-primary {
  background-color: #275262 !important;
  color: white;
}
.form-render .formLoader {
  position: absolute;
  width: 100%;
  z-index: 1232132132;
  background: rgba(255, 255, 255, 0.5607843137);
  margin: -5px;
  justify-content: center;
  display: flex;
  flex-flow: column;
  align-content: center;
  align-items: center;
}
.form-render .text-muted {
  color: #ddd;
}
.form-render .form-control[disabled=disabled] {
  background-color: #e9ecef;
}
.form-render .file {
  background: #f8d7da;
  margin: 10px;
  padding: 0px 13px 10px 13px;
  border-radius: 10px;
}
.form-render .file .fileName {
  padding-bottom: 5px;
}
.form-render nav .pagination {
  flex-wrap: wrap;
}
.form-render .formio-component-file a:not([href]) {
  color: #007bff;
  cursor: pointer;
}
.form-render .formio-component-file a[ref*=toggleCameraMode] {
  display: none;
}
.form-render .inputRange {
  position: relative;
  height: 5px;
  width: 100%;
}
.form-render .inputRange input[type=range] {
  -webkit-appearance: none;
  display: block;
  margin: 0;
  width: 100%;
  background: transparent;
}
.form-render .inputRange input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  height: 3px;
  cursor: pointer;
  background: #b2b2b2;
}
.form-render .inputRange input[type=range]::-moz-range-track {
  width: 100%;
  height: 3px;
  cursor: pointer;
  background: #b2b2b2;
}
.form-render .inputRange input[type=range]::-ms-track {
  width: 100%;
  height: 3px;
  cursor: pointer;
  background: #b2b2b2;
}
.form-render .inputRange input[type=range]::-ms-fill-lower {
  display: none;
}
.form-render .inputRange input[type=range]::-ms-fill-upper {
  display: none;
}
.form-render .inputRange input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  margin: -8px 0 0;
  border-radius: 50%;
  background: #37adbf;
  cursor: pointer;
  border: 0 !important;
  box-shadow: 100% 0 0 100% #43e5f7;
}
.form-render .inputRange input[type=range]::-moz-range-thumb {
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  margin: -8px 0 0;
  border-radius: 50%;
  background: #37adbf;
  cursor: pointer;
  border: 0 !important;
}
.form-render .inputRange input[type=range]::-ms-thumb {
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  margin: -8px 0 0;
  border-radius: 50%;
  background: #37adbf;
  cursor: pointer;
  border: 0 !important;
}
.form-render {
  /* input[type=range]::-moz-range-progress {
    height: 8px;
    background: #37adbf;
    border: 0;
    margin-top: 0;
  } */
}
.form-render .ticks {
  display: flex;
  justify-content: space-between;
  padding: 0px 4px;
  margin-top: -6px;
}
.form-render .ticks li {
  position: relative;
  display: flex;
  justify-content: center;
  width: 10px;
  background: #37adbf;
  height: 10px;
  line-height: 50px;
  border-radius: 50%;
  margin-bottom: 20px;
  cursor: pointer;
}
.form-render .ticks .active {
  color: #37adbf;
}
.form-render .ticks .selected::before {
  background: #37adbf;
}
.form-render .ticks .active.selected::before {
  display: none;
}
.form-render .labels {
  width: 100%;
}
.form-render .card-input-element {
  display: none;
}
.form-render .card-input {
  margin: 10px;
  padding: 0px;
  box-shadow: 0 0 1px 1px #37adbf;
  color: #37adbf;
}
.form-render .card-input:hover {
  cursor: pointer;
}
.form-render .card-input-element:checked + .card-input {
  box-shadow: 0 0 1px 1px #37adbf;
  color: #fff;
  background-color: #37adbf;
}
.form-render .padding-0 {
  padding-right: 0;
  padding-left: 0;
}
.form-render .formio-component-radio.formio-component-label-hidden.required .label-position-right.form-check-label:before,
.form-render .formio-component-selectboxes.formio-component-label-hidden.required .label-position-right.form-check-label:before {
  right: unset;
}

.form-render.hideBredcrumb .formio-form nav[aria-label=navigation] {
  display: none;
}

.formLoader {
  position: absolute;
  height: 100%;
}

.formloader-spinner {
  top: 50%;
  z-index: 111;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.5607843137);
}

.formBuilder #form-save-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  font-family: Quicksand;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 25px;
  color: #275362;
}
.formBuilder #form-save-button .form-group {
  margin-bottom: unset;
  border: 1px solid #b5cbda;
  box-sizing: border-box;
  box-shadow: inset 0px 1px 1px 1px #b5cbda;
  border-radius: 8px;
}

.flatpickr-calendar {
  top: auto;
}`, "",{"version":3,"sources":["webpack://./../gui/src/public/css/formstyles.scss"],"names":[],"mappings":"AAIM;EACE,aAAA;AAHR;AAOE;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;AALJ;AAOE;EACE,eAAA;AALJ;AAOE;EACE,eAAA;EACA,iBAAA;AALJ;AAQI;EACE,oBAAA;EACA;;;;;cAAA;AADN;AASE;EACE,6BAAA;EACA,yBAAA;EACA,UAAA;AAPJ;AAWI;EACE,yDAAA;AATN;AAYI;EACE,kBAAA;AAVN;AAeI;EACE,oBAAA;EACA,iBAAA;AAbN;AAcM;EACE,eAAA;AAZR;AAiBE;EACE,cAAA;EACA,cAAA;EACA,eAAA;AAfJ;AAkBE;EACE,yBAAA;AAhBJ;AAkBE;EACE,oCAAA;EACA,uBAAA;AAhBJ;AAmBE;EACE,oCAAA;EACA,YAAA;AAjBJ;AAmBE;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,6CAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;AAjBJ;AAmBE;EACE,WAAA;AAjBJ;AAmBE;EACE,yBAAA;AAjBJ;AAmBE;EACE,mBAAA;EACA,YAAA;EACA,2BAAA;EACA,mBAAA;AAjBJ;AAmBI;EACE,mBAAA;AAjBN;AAsBI;EACE,eAAA;AApBN;AAyBI;EACE,cAAA;EACA,eAAA;AAvBN;AA0BI;EACE,aAAA;AAxBN;AAuCE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;AArCJ;AAuCE;EACE,wBAAA;EACA,cAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;AArCJ;AAwCE;EACE,WAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;AAtCJ;AAyCE;EACE,WAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;AAvCJ;AA0CE;EACE,WAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;AAxCJ;AA2CE;EACE,aAAA;AAzCJ;AA4CE;EACE,aAAA;AA1CJ;AA6CE;EACE,wBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,iCAAA;AA3CJ;AA8CE;EACE,wBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AA5CJ;AA+CE;EACE,wBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AA7CJ;AAjKA;EAgNE;;;;;KAAA;AAvCF;AA8CE;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,gBAAA;AA5CJ;AA+CE;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AA7CJ;AAgDE;EACE,cAAA;AA9CJ;AAgDE;EACE,mBAAA;AA9CJ;AAgDE;EACE,aAAA;AA9CJ;AAgDE;EACE,WAAA;AA9CJ;AAiDE;EACE,aAAA;AA/CJ;AAkDE;EACE,YAAA;EACA,YAAA;EACA,+BAAA;EACA,cAAA;AAhDJ;AAmDE;EACE,eAAA;AAjDJ;AAoDE;EACE,+BAAA;EACA,WAAA;EACA,yBAAA;AAlDJ;AAqDE;EACE,gBAAA;EACA,eAAA;AAnDJ;AAsDE;;EAIE,YAAA;AAtDJ;;AA2DE;EACE,aAAA;AAxDJ;;AA4DA;EACE,kBAAA;EACA,YAAA;AAzDF;;AA6DA;EACE,QAAA;EACA,YAAA;EACA,SAAA;EACA,gCAAA;EACA,6CAAA;AA1DF;;AA6DE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA1DJ;AA4DI;EACE,oBAAA;EACA,yBAAA;EACA,sBAAA;EACA,yCAAA;EACA,kBAAA;AA1DN;;AA8DA;EACE,SAAA;AA3DF","sourcesContent":[".form-render {\n\n  .formio-component-well {\n    p {\n      li {\n        padding: 10px;\n      }\n    }\n  }\n  .formio-component-filecomponent .fileSelector {\n    padding: 15px;\n    border: 2px dashed #ddd;\n    text-align: center;\n  }\n  .formio-component-filecomponent .fileSelector .browse {\n    cursor: pointer;\n  }\n  .formio-component-filecomponent .fileSelector .fa {\n    font-size: 20px;\n    margin-right: 5px;\n  }\n  label {\n    span {\n      color: darkslategray;\n      /*font-family: Quicksand;\n\tfont-style: normal;\n\tfont-weight: normal;\n\tfont-size: 20px;\n\tline-height: 25px;\n\tcolor: red;*/\n    }\n  }\n  .formio-error-wrapper {\n    background-color: transparent;\n    border-color: transparent;\n    padding: 0;\n  }\n\n  .formio-component-select {\n    .form-control.is-invalid.dropdown {\n      background-position: right calc(2.8em + 0.1875rem) center;\n    }\n\n    .choices__list--dropdown.is-active {\n      position: relative;\n    }\n  }\n\n  .formio-component-modal-wrapper {\n    .formio-dialog.formio-dialog-theme-default {\n      padding-bottom: 50px;\n      padding-top: 50px;\n      .formio-dialog-content {\n        min-height: 80%;\n      }\n    }\n  }\n\n  .formio-component.has-feedback .invalid-feedback {\n    display: block;\n    color: inherit;\n    margin-top: 4px;\n  }\n\n  .page-item > button.page-link {\n    color: #275362 !important;\n  }\n  .page-item.active > button {\n    background-color: #275362 !important;\n    color: white !important;\n  }\n\n  .bg-primary {\n    background-color: #275262 !important;\n    color: white;\n  }\n  .formLoader {\n    position: absolute;\n    width: 100%;\n    z-index: 1232132132;\n    background: #ffffff8f;\n    margin: -5px;\n    justify-content: center;\n    display: flex;\n    flex-flow: column;\n    align-content: center;\n    align-items: center;\n  }\n  .text-muted {\n    color: #ddd;\n  }\n  .form-control[disabled=\"disabled\"] {\n    background-color: #e9ecef;\n  }\n  .file {\n    background: #f8d7da;\n    margin: 10px;\n    padding: 0px 13px 10px 13px;\n    border-radius: 10px;\n\n    .fileName {\n      padding-bottom: 5px;\n    }\n  }\n\n  nav {\n    .pagination {\n      flex-wrap: wrap;\n    }\n  }\n\n  .formio-component-file {\n    a:not([href]) {\n      color: #007bff;\n      cursor: pointer;\n    }\n\n    a[ref*=\"toggleCameraMode\"] {\n      display: none;\n    }\n  }\n  // * {\n  //   box-sizing: border-box;\n  // }\n\n  // body {\n  //   font-family: sans-serif;\n  //   font-size: 16px;\n  //   line-height: 20px;\n  //   color: black;\n  //   background: white;\n  // }\n\n  .inputRange {\n    position: relative;\n    height: 5px;\n    width: 100%;\n  }\n  .inputRange input[type=\"range\"] {\n    -webkit-appearance: none;\n    display: block;\n    margin: 0;\n    width: 100%;\n    background: transparent;\n  }\n\n  .inputRange input[type=\"range\"]::-webkit-slider-runnable-track {\n    width: 100%;\n    height: 3px;\n    cursor: pointer;\n    background: #b2b2b2;\n  }\n\n  .inputRange input[type=\"range\"]::-moz-range-track {\n    width: 100%;\n    height: 3px;\n    cursor: pointer;\n    background: #b2b2b2;\n  }\n\n  .inputRange input[type=\"range\"]::-ms-track {\n    width: 100%;\n    height: 3px;\n    cursor: pointer;\n    background: #b2b2b2;\n  }\n\n  .inputRange input[type=\"range\"]::-ms-fill-lower {\n    display: none;\n  }\n\n  .inputRange input[type=\"range\"]::-ms-fill-upper {\n    display: none;\n  }\n\n  .inputRange input[type=\"range\"]::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    width: 20px;\n    height: 20px;\n    margin: -8px 0 0;\n    border-radius: 50%;\n    background: #37adbf;\n    cursor: pointer;\n    border: 0 !important;\n    box-shadow: 100% 0 0 100% #43e5f7;\n  }\n\n  .inputRange input[type=\"range\"]::-moz-range-thumb {\n    -webkit-appearance: none;\n    width: 20px;\n    height: 20px;\n    margin: -8px 0 0;\n    border-radius: 50%;\n    background: #37adbf;\n    cursor: pointer;\n    border: 0 !important;\n  }\n\n  .inputRange input[type=\"range\"]::-ms-thumb {\n    -webkit-appearance: none;\n    width: 20px;\n    height: 20px;\n    margin: -8px 0 0;\n    border-radius: 50%;\n    background: #37adbf;\n    cursor: pointer;\n    border: 0 !important;\n  }\n  /* input[type=range]::-moz-range-progress {\n    height: 8px;\n    background: #37adbf;\n    border: 0;\n    margin-top: 0;\n  } */\n\n  .ticks {\n    display: flex;\n    justify-content: space-between;\n    padding: 0px 4px;\n    margin-top: -6px;\n  }\n\n  .ticks li {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    width: 10px;\n    background: #37adbf;\n    height: 10px;\n    line-height: 50px;\n    border-radius: 50%;\n    margin-bottom: 20px;\n    cursor: pointer;\n  }\n\n  .ticks .active {\n    color: #37adbf;\n  }\n  .ticks .selected::before {\n    background: #37adbf;\n  }\n  .ticks .active.selected::before {\n    display: none;\n  }\n  .labels {\n    width: 100%;\n  }\n\n  .card-input-element {\n    display: none;\n  }\n\n  .card-input {\n    margin: 10px;\n    padding: 00px;\n    box-shadow: 0 0 1px 1px #37adbf;\n    color: #37adbf;\n  }\n\n  .card-input:hover {\n    cursor: pointer;\n  }\n\n  .card-input-element:checked + .card-input {\n    box-shadow: 0 0 1px 1px #37adbf;\n    color: #fff;\n    background-color: #37adbf;\n  }\n\n  .padding-0 {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .formio-component-radio.formio-component-label-hidden.required\n    .label-position-right.form-check-label:before,\n  .formio-component-selectboxes.formio-component-label-hidden.required\n    .label-position-right.form-check-label:before {\n    right: unset;\n  }\n}\n\n.form-render.hideBredcrumb {\n  .formio-form nav[aria-label=\"navigation\"] {\n    display: none;\n  }\n}\n\n.formLoader {\n  position: absolute;\n  height: 100%;\n  // width: 100%;\n}\n\n.formloader-spinner {\n  top: 50%;\n  z-index: 111;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: #ffffff8f;\n}\n.formBuilder {\n  #form-save-button {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-evenly;\n    font-family: Quicksand;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 25px;\n    color: #275362;\n\n    .form-group {\n      margin-bottom: unset;\n      border: 1px solid #b5cbda;\n      box-sizing: border-box;\n      box-shadow: inset 0px 1px 1px 1px #b5cbda;\n      border-radius: 8px;\n    }\n  }\n}\n.flatpickr-calendar{\n  top: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
